/**
 * Message times, the friendly way: "just now", "5m ago", "2h ago" within
 * the last day, then just the date ("28 Sep", with the year once it isn't
 * this year) — a date is noise on something recent, a clock time noise on
 * something old. `fullTime` is the exact moment, for a tooltip.
 */

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** ms since the epoch. The backend sends naive UTC (no zone), which
 *  `new Date` would otherwise read as local time. */
export function parseTimestamp(at) {
    if (at == null || at === '') return null;
    if (at instanceof Date || typeof at === 'number') return new Date(at).getTime();
    const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(at);
    const ms = new Date(hasZone ? at : `${at}Z`).getTime();
    return Number.isNaN(ms) ? null : ms;
}

export function friendlyTime(at, now = Date.now()) {
    const ms = parseTimestamp(at);
    if (ms == null) return '';
    // A little clock skew can put a fresh message in the future — still "just now".
    const age = Math.max(0, now - ms);
    if (age < MINUTE) return 'just now';
    if (age < HOUR) return `${Math.floor(age / MINUTE)}m ago`;
    if (age < DAY) return `${Math.floor(age / HOUR)}h ago`;
    const date = new Date(ms);
    const sameYear = date.getFullYear() === new Date(now).getFullYear();
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
}

export function fullTime(at) {
    const ms = parseTimestamp(at);
    return ms == null ? '' : new Date(ms).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
